"use client"

import { cn } from "@/lib/utils"
import { XMarkIcon } from "@heroicons/react/24/outline"

interface RemovableTagProps {
  tag: string
  onRemove: (tag: string) => void
  className?: string
  variant?: "default" | "accent"
}

export function RemovableTag({
  tag,
  onRemove,
  className = "",
  variant = "default",
}: RemovableTagProps) {
  const baseStyles = cn(
    "flex items-center rounded-full px-3 py-1.5 text-sm",
    variant === "accent"
      ? "bg-accent-color text-accent-fg"
      : "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300",
    className
  )

  const handleRemove = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onRemove(tag)
  }

  return (
    <div className={baseStyles}>
      <span>{tag}</span>
      <button
        type="button"
        onClick={handleRemove}
        aria-label={`Remove ${tag} tag`}
        className="ml-1.5 rounded-full p-0.5 hover:bg-gray-200 hover:text-gray-700 dark:hover:bg-gray-700"
      >
        <XMarkIcon className="h-3.5 w-3.5" />
      </button>
    </div>
  )
}
